/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */
declare global {
    interface Window {
        Trustpilot: any;
    }
}

import * as React from 'react';
import { IDobbiesTrustpilotViewProps } from './dobbies-trustpilot';

export default (props: IDobbiesTrustpilotViewProps) => {
    const ref = React.useRef(null);
    React.useEffect(() => {
        if (window.Trustpilot) {
            window.Trustpilot.loadFromElement(ref.current, true);
        }
    }, []);
    const { config } = props;
    if (config.dataTags) {
        return (
            <div
                ref={ref}
                className={config.classname ? config.classname : 'trustpilot-widget'}
                data-locale={config.dataLocale ? config.dataLocale : 'en-US'}
                data-template-id={config.dataTemplateId ? config.dataTemplateId : '5406e65db0d04a09e042d5fc'}
                data-businessunit-id={config.dataBusinessunitId ? config.dataBusinessunitId : '4b1d7776000064000504d8b0'}
                data-style-height={config.dataStyleHeight ? config.dataStyleHeight : '28px'}
                data-style-width={config.dataStyleWidth ? config.dataStyleWidth : '100%'}
                data-theme={config.dataTheme ? config.dataTheme : 'light'}
                data-tags={config.dataTags ? config.dataTags : 'Loyalty'}
                data-stars={config.dataStars ? config.dataStars : '4,5'}
            >
                <a href='https://www.trustpilot.com/review/example.com' target='_blank' rel='noopener noreferrer'>
                    {' '}
                    Trustpilot
                </a>
            </div>
        );
    } else {
        return (
            <div
                ref={ref}
                className={config.classname ? config.classname : 'trustpilot-widget'}
                data-locale={config.dataLocale ? config.dataLocale : 'en-US'}
                data-template-id={config.dataTemplateId ? config.dataTemplateId : '5406e65db0d04a09e042d5fc'}
                data-businessunit-id={config.dataBusinessunitId ? config.dataBusinessunitId : '4b1d7776000064000504d8b0'}
                data-style-height={config.dataStyleHeight ? config.dataStyleHeight : '28px'}
                data-style-width={config.dataStyleWidth ? config.dataStyleWidth : '100%'}
                data-theme={config.dataTheme ? config.dataTheme : 'light'}
                data-stars={config.dataStars ? config.dataStars : '4,5'}
            >
                <a href='https://www.trustpilot.com/review/example.com' target='_blank' rel='noopener noreferrer'>
                    {' '}
                    Trustpilot
                </a>
            </div>
        );
    }
};
